export default "__VITE_ASSET__nBDUBdmF__"